import { ethers } from 'ethers'

function normalizedDecimals(decimals) {
    const parsed = parseInt(String(decimals ?? 18), 10)
    return Number.isInteger(parsed) && parsed >= 0 ? parsed : 18
}

export function formatTokenAmount(rawAmount, decimals = 18, maximumFractionDigits = 6) {
    if (rawAmount === undefined || rawAmount === null || rawAmount === '') return '0'
    let formatted
    try {
        formatted = ethers.utils.formatUnits(rawAmount.toString(), normalizedDecimals(decimals))
    } catch (_error) {
        return '0'
    }
    const [whole, fraction = ''] = formatted.split('.')
    const visibleFraction = fraction
        .slice(0, Math.max(0, parseInt(String(maximumFractionDigits), 10) || 0))
        .replace(/0+$/, '')
    return visibleFraction ? `${whole}.${visibleFraction}` : whole
}

export function formatIntegerAmount(rawAmount) {
    if (rawAmount === undefined || rawAmount === null || rawAmount === '') return '0'
    try {
        return ethers.BigNumber.from(rawAmount.toString()).toString()
    } catch (_error) {
        return '0'
    }
}
